import React, {
  useEffect,
} from "react";

import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";
import LdsKalturaPlayer from "../../components/LdsVideoPlayer/KalturaPlayer";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsVideoPlayer from "../../components/LdsVideoPlayer";
import LdsFigureCaption from "../../components/LdsFigureCaption";
import References from "../../components/References";


// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  function navClick(navLink) {
    window.open(navLink, "_self");
  }

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.1 Demonstration Case 1: Negative
            </h1>
            <p className="me-4">Estimated time to complete: 4 minutes</p>
          </section>

          <section className="row justify-content-center">
            <div className="col-lg-8 col-sm-12 mt-4 mb-4">
              <LdsFigureCaption
                textContent={
                  <>
                    <p>
                      <strong>AUDIO</strong>
                      <br />
                      VO: (FEMALE)
                      <br />
                    </p>
                    <p>
                      This is Demonstration Case Number 1. This is a negative
                      scan. The size and contrast have already been adjusted.
                    </p>
                    <p>
                      We will begin at the bottom of the brain and move
                      superiorly one slice at a time through the entire brain.
                      At this point, we are entering the cerebellum. You can
                      always orient yourself to where you are by looking at the
                      accompanying sagittal and coronal images and identifying
                      the small green lines or crosshairs that show what level
                      you are at in the brain. Returning to the transverse
                      image, we see intense uptake in the white matter of the
                      cerebellum, surrounded by less intense uptake in the gray
                      matter. The coronal images also show the cerebellum. Here,
                      you see intense uptake in the white matter, again
                      surrounded by less intense uptake in the gray matter. In
                      both positive and negative cases, the cerebellum maintains
                      normal gray-white contrast, and it allows us to understand
                      the gray-white contrast for each patient.
                    </p>
                    <p>
                      As we continue to move upward through the cerebellum, we
                      now see the temporal lobes and the occipital lobes. This
                      demonstrates the delineation of the white matter tracts
                      from the temporal to the occipital lobes on both sides of
                      the brain. The white matter tracts are surrounded by less
                      intense uptake in the gray matter on both sides of the
                      brain. In addition, finger-like projections of white
                      matter activity are seen extending into the surrounding
                      gray matter. This contrast of white matter to gray matter
                      is normal.
                    </p>
                    <p>
                      Coronal images seen here may also be used to verify
                      gray/white contrast in a region. Here in the temporal
                      lobe, intense uptake is seen in the white matter on either
                      side, surrounded by less intense uptake in the cortical
                      gray matter.
                    </p>
                    <p>
                      Returning to the transverse images and again moving
                      superiorly, we enter the frontal cortex. Here, you may see
                      concave-like structures of the white matter within the
                      frontal cortex. In addition, finger-like projections of
                      white matter, extending into the surrounding and less
                      intense gray matter, may also be seen. Again, this
                      contrast or preserved gray-white differentiation is
                      normal.
                    </p>
                    <p>As we move more superiorly, the delineation of white matter tracts can be seen from the front of the brain to the back of the brain. In the parietal lobes, less intense activity is also seen in the medial parietal region. In a positive scan, increased activity may be found here, also known as the precuneus. However, on this scan, there is no increased activity and there is normal gray-white contrast on both sides of the brain.</p>
                    <p>Always ensure that all slices of the brain are viewed. If necessary, you can use the sagittal images to return to the bottom of the brain to review any slices of concern. These images demonstrate normal gray-white contrast throughout the brain.</p>
                    <p>This scan is negative.</p>
                  </>
                }
                buttonIcon="MinusCircle"
                buttonTextAlign="left"
                showDescriptionText="Video Transcript"
                hideDescriptionText="Video Transcript"
                radiusSize="small"
              >
                <LdsVideoPlayer brandBorder={false}>
                  <LdsKalturaPlayer
                    videoId="1_rpfg6ma7"
                    partnerId="1759891"
                    uiConfId="54959122"
                    nextUrl="/module-2/module-2-3-2"
                  />
                </LdsVideoPlayer>
              </LdsFigureCaption>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={() => navClick("/module-2/module-2-3-0")}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              id="next"
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              disabled={true}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
